import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesSharing } from "../../constants";
import { ProductsSharingsListItem } from "../../sharing.types";

export const requestProductsSharings = async (
  params: GetListRequestParams
): Promise<GetListResponse<ProductsSharingsListItem>> => {
  return await instance.get(ApiRoutesSharing.ProductSharings, {
    params
  });
};
